module.exports = __webpack_public_path__ + "static/media/ios-cloud-upload.fea5c37a.svg";